import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { INavigationResponse } from '../models/settings.model';
import { GlueConfigurationService } from './glue-configuration.service';
import { AppUtils } from '../utils/app.utils';
import { Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CustomerFacade } from '../facades/customer.facade';

@Injectable({
  providedIn: 'root'
})
export class NavigationBarService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);
  private readonly router: Router = inject(Router);
  private readonly customerFacade: CustomerFacade = inject(CustomerFacade);

  private readonly glueUrl: string = this.glueConfiguration.getEndpointUrl();

  private static handleError(error: any): Promise<INavigationResponse> {
    console.error('An error occurred in getNavigationBar()', error);
    return Promise.reject(error.message || error);
  }

  getNavigationBar(): Observable<INavigationResponse> {
    return this.customerFacade.selectIsGuest().pipe(
      switchMap(isGuest => {
        const navigationBarUrl: string = this.glueUrl + `/navigations/${isGuest ? 'GUEST_' : ''}MAIN_NAVIGATION`;
        return this.http.get<INavigationResponse>(navigationBarUrl).pipe(
          catchError(NavigationBarService.handleError),
        );
      })
    );
  }

  getShopCategoryNavigationBar(): Observable<INavigationResponse> {
    const shopCategoryNavBarUrl: string = this.glueUrl + `/navigations/${AppUtils.getCurrentStore().storeId}_HOMEPAGE_TILES_BAR`;

    return this.http.get<INavigationResponse>(shopCategoryNavBarUrl).pipe(
      map(response => {
        return this._resolveUrlQueryParams(response);
      }),
      catchError(NavigationBarService.handleError),
    );
  }

  private _resolveUrlQueryParams(shopCategoryResponse: INavigationResponse): INavigationResponse {
    shopCategoryResponse.data.attributes.nodes.forEach((url) => {
      if (url.url) {
        url.queryParams = this.router.parseUrl(url.url).queryParams;
        url.url = url.url.includes('?')
          ? url.url.substring(0, url.url.indexOf('?'))
          : url.url;
      }
    });
    return shopCategoryResponse;
  }
}
